import { gql } from '@apollo/client';

export const FETCH_FLATFILE_KEY = gql`
  query FetchFlatFileKey {
    flatfilekey: fetchFlatFileKey {
      key
    }
  }
`;
